// General
import React, { useState, useContext, useRef } from "react";

// Context
import { ActionContext } from "../data/action/ActionContext";
import { SubActionContext } from "../data/action/SubActionContext";
import { useData } from "../data/general/DataContext";

// Pages / Core Components
import TablePage from "../core/TablePage";

// Modals
import ActionAddModal from "../modals/action/ActionAddModal";
import ActionUpdateModal from "../modals/action/ActionUpdateModal";

// UI Components / Icons
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { FaTrash, FaPencilAlt } from "react-icons/fa";
//Function

function ActionPage() {
  const { actions, addAction, updateAction, deleteAction } = useContext(ActionContext);
  const { subActions } = useContext(SubActionContext);
  const { windowMode } = useData();

  const [showAddModal, setShowAddModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);


  const getSubActionNames = (ids) => {
    return ids
      ?.map((id) => subActions.find((s) => s.id === id)?.name)
      .filter(Boolean)
      .join(", ");
  };


  const ActionMenu = ({ rowData }) => {
    const op = useRef(null);
    if (windowMode === "mobile") return null;

    return (
      <>
        <Button
          label="..."
          className="p-button-rounded p-button-text"
          style={{ minWidth: "40px", fontSize: "22px", fontWeight: "bold" }}
          onClick={(e) => op.current.toggle(e)}
        />
        <OverlayPanel ref={op} dismissable showCloseIcon={false} style={{ padding: "0.5rem", left: "-5px" }}>
          <div className="flex flex-col gap-0 p-2 w-32">
            <Button
              icon={<FaPencilAlt />}
              label="Düzenle"
              className="p-button-text w-full justify-start"
              style={{ fontSize: "14px", gap: "10px" }}
              onClick={() => {
                setSelectedAction(rowData);
                setShowUpdateModal(true);
                op.current.hide();
              }}
            />
            <div className="w-full border-t border-gray-300 my-1"></div>
            <Button
              icon={<FaTrash />}
              label="Sil"
              className="p-button-text w-full justify-start"
              style={{ color: "red", fontSize: "14px", gap: "10px" }}
              onClick={() => {
                deleteAction(rowData.id);
                op.current.hide();
              }}
            />
          </div>
        </OverlayPanel>
      </>
    );
  };

  const columns = [
    { field: "id", header: "ID", hideInFilter: true },
    { field: "name", header: "Aksiyon Adı" },
    {
      field: "subActions",
      header: "Alt Aksiyonlar",
      body: (rowData) =>
        rowData.subActions && rowData.subActions.length > 0
          ? getSubActionNames(rowData.subActions)
          : "-",
    },
    {
      header: "İşlemler",
      body: (rowData) =>
        windowMode === "mobile" ? (
          <div className="flex gap-2 mt-2 w-full">
            <Button
              icon={<FaPencilAlt />}
              label="Düzenle"
              className="flex-1"
              style={{
                backgroundColor: "#3b82f6",
                color: "white",
                border: "none",
                borderRadius: "6px",
                height: "26px",
                fontSize: "10px",
                justifyContent: "center",
                gap: "4px",
                padding: "0 6px",
              }}
              onClick={() => {
                setSelectedAction(rowData);
                setShowUpdateModal(true);
              }}
            />
            <Button
              icon={<FaTrash />}
              label="Sil"
              className="flex-1"
              style={{
                backgroundColor: "#ef4444",
                color: "white",
                border: "none",
                borderRadius: "6px",
                height: "26px",
                fontSize: "10px",
                justifyContent: "center",
                gap: "4px",
                padding: "0 6px",
              }}
              onClick={() => deleteAction(rowData.id)}
            />
          </div>
        ) : (
          <ActionMenu rowData={rowData} />
        ),
      hideInFilter: true,
    },
  ];



  return (
    <>
      <div className="p-6">
        <TablePage
          title="Aksiyon Listesi"
          subTitle="Aksiyon ekleyebilir, düzenleyebilir veya silebilirsiniz."
          columns={columns}
          data={actions}
          defaultRows={10}
          rowsPerPageOptions={[10, 15, 25, 50,100]}
          showSearch
          onAdd={() => setShowAddModal(true)}
        />
      </div>

      <ActionAddModal
        show={showAddModal}
        handleClose={() => setShowAddModal(false)}
        onSubmit={(newAction) => addAction(newAction.name, newAction.subActions)}
      />

      <ActionUpdateModal
        show={showUpdateModal}
        handleClose={() => setShowUpdateModal(false)}
        action={selectedAction}
        onSubmit={(id, name) => updateAction(id, name)}
      />
    </>
  );
}

export default ActionPage;
